import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface DayHeaderProps {
  day: number | string;
  cities: string[];
}

function DayHeader({ day, cities }: DayHeaderProps) {
  const cityText = cities.length > 0
    ? ` - ${cities.join(' and ')}`
    : '';

  return (
    <Box sx={{ mb: 2 }}>
      <Typography
        variant="h5"
        gutterBottom
        color="primary"
        sx={{ fontWeight: 'bold', mb: 3, textAlign: 'center' }}
      >
        Day {day}{cityText}
      </Typography>
    </Box>
  );
}

export default DayHeader;
